import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {BrowserRouter} from "react-router-dom";
import { I18nextProvider } from 'react-i18next';

import App from './components/app';
import store from "./store";
import LoanApiService from "./components/services/loan-api-service";
import {LoanServiceProvider} from "./components/loan-service-context";
import i18n from "./translations/i18n"

const loanService = new LoanApiService();
ReactDOM.render(

    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
        <LoanServiceProvider value={loanService}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </LoanServiceProvider>
        </I18nextProvider>
    </Provider>,
    document.getElementById('root'));